
const initialState = {
    account: {
        id: 0,
        services: [],
        dialActions: [],
        isFetching: false,
        didInvalidate: false,
        error: null,
    },
    user: {
        id: 0,
    },
    endpoint: {}
}

export default initialState;